import type { FetchAgreementsReportResult } from '../../agreements/report/fetch-agreements-report';
import type { DwtPayloadsTaskPaneFilter } from '../models/dwt-payloads.model';
import { buildDwtPayloadsPayloadFromFilter } from '../utils/dwt-payloads-filter-payload.builder';
import type { DwtPayloadsReportFetchDeps } from './dwt-payloads-fetch.deps';
import { defaultDwtPayloadsReportFetchDeps } from './dwt-payloads-fetch.deps';

/**
 * DWT payloads feature: Get-RegulatoryReports only (no Excel). Task pane formats records and writes.
 */
export async function fetchDwtPayloadsReport(
    accessToken: string,
    filter: DwtPayloadsTaskPaneFilter,
    deps: DwtPayloadsReportFetchDeps = defaultDwtPayloadsReportFetchDeps
): Promise<FetchAgreementsReportResult> {
    const payload = buildDwtPayloadsPayloadFromFilter(filter);
    const result = await deps.fetchGetDwtPayloads(accessToken, payload);

    if (result.kind === 'failure') {
        const source = result.source ?? 'http';
        return {
            kind: 'failure',
            message: result.message,
            source,
            ...(result.invalidElementIds !== undefined
                ? { invalidElementIds: result.invalidElementIds }
                : {}),
            ...(result.httpStatus !== undefined ? { httpStatus: result.httpStatus } : {}),
            ...(result.body !== undefined ? { body: result.body } : {}),
            debugErrorTitle: source === 'validation' ? 'Invalid filters' : 'Report fetch failed',
        };
    }

    const { body, records, totalCount, recordCount, httpStatus } = result;
    return {
        kind: 'success',
        records,
        recordCount,
        totalCount,
        body,
        httpStatus,
    };
}
